import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useStyles } from './styles';
import { RateQuestionProps } from './interfaces';
import { RATE_LABELS } from '../../constants';

const RateQuestion: React.FC<RateQuestionProps> = ({
  question,
  selectedValue,
  onSelect,
}) => {
  const classes = useStyles();

  const renderRatingButtons = () => {
    const buttons = [];
    for (let i = question.minValue; i <= question.maxValue; i++) {
      const isSelected = selectedValue === i;
      buttons.push(
        <Button
          key={i}
          onClick={() => onSelect(i)}
          sx={{
            ...classes.ratingButton,
            ...(isSelected ? classes.ratingButtonSelected : {}),
          }}
        >
          {i}
        </Button>,
      );
    }
    return buttons;
  };

  const getRatingDescription = (value: number) => {
    const labels = RATE_LABELS[question.id] || {};
    return labels[value] || '';
  };

  return (
    <Box sx={classes.container}>
      <Box sx={classes.ratingButtonsContainer}>{renderRatingButtons()}</Box>

      <Box sx={classes.selectedValueContainer}>
        {selectedValue && (
          <Typography sx={classes.selectedValueText}>
            You&apos;ve selected: {selectedValue} -{' '}
            {getRatingDescription(selectedValue)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default RateQuestion;
